/**
 * 物业相关api
 *
 * @param http
 * @returns {{pushError2DingTalk(*): *, modifyPassword(*): *, queryAll(*): *}|*}
 */
export default (http) => {
    return {
        queryByPage (data){
            return http.json({
                url: '/system/property/query',
                data
            })
        },
        /**
         * 保存信息
         * @param data
         * @returns {*}
         */
        save(data) {
            return http.json({
                url: '/system/property/save',
                data
            })
        },
        /**
         * 获取详情
         * @param data
         * @return {*}
         */
        get(data) {
            return http.json({
                url: `/system/property/get?id=${data.id}`
            })
        },
        /**
         * 删除
         * @param data
         * @returns {*}
         */
        delete(data) {
            return http.json({
                url: `/system/property/delete?id=${data[0].id}`,
                data
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/property.js